import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class AccountMenuService {
  private readonly translateService = inject(TranslateService);

  private readonly menuItems = signal<MenuItem[]>([
    {
      separator: true,
    },
    {
      id: 'signOut',
      label: this.translateService.instant('common.signOut'),
      icon: 'pi pi-sign-out',
      linkClass: '!text-red-500 dark:!text-red-400',
    },
  ]);

  getAccountMenuItems(): WritableSignal<MenuItem[]> {
    return this.menuItems;
  }

  setMenuItemCommand(id: string, command: () => void): void {
    this.menuItems.update((items) =>
      items.map((item) => (item.id === id ? { ...item, command } : item)),
    );
  }
}
